<script lang="ts">
    import { requests, setupSharedProps, sharedProps } from "../services";
    import Image from "@lernetz/svelte-image/components/Image.svelte";
    import { Link } from "@inertiajs/svelte";
    import { getLocale } from '../utils/getLocale';

    export let model;
    let image = model.image;
    const locale = getLocale();

    setupSharedProps();


</script>

<Link href="/{locale}/houses/{model.id}">
    <div class="h-[350px] rounded-2xl flex flex-col transition-all duration-200 bg-light-grey hover:bg-medium-grey relative overflow-hidden">
        <div class="m-auto">
            <div class="relative w-240 h-240 aspect-[1/1]">
                {#if model.image}
                    <Image
                        class="w-full absolute inset-0 object-cover z-0"
                        request={requests.assets}
                        vars={{ file_name: image?.file_name, preset: "medium.png" }}
                    />
                {/if}
            </div>
            <div class="px-24 pb-24">
                <div class="h-[48px] flex items-center justify-center">
                    <span class="text-almost-black text-16 text-center font-bold text-ellipsis overflow-hidden">{model.title}</span>
                </div>
            </div>
        </div>
    </div>
</Link>
